import { render } from "./AllPage.vue?vue&type=template&id=30a6686b&scoped=true"
import script from "./AllPage.vue?vue&type=script&lang=js"
export * from "./AllPage.vue?vue&type=script&lang=js"

import "./AllPage.vue?vue&type=style&index=0&id=30a6686b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a6686b"],['__file',"src/views/AfterSales/AllPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30a6686b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30a6686b', __exports__)) {
    api.reload('30a6686b', __exports__)
  }
  
  module.hot.accept("./AllPage.vue?vue&type=template&id=30a6686b&scoped=true", () => {
    api.rerender('30a6686b', render)
  })

}


export default __exports__